import type { LeaveColour } from './types'

/** Solid swatch classes per colour token (static strings so Tailwind keeps them). */
export const leaveSwatch: Record<LeaveColour, string> = {
  brand: 'bg-brand-500',
  success: 'bg-success-500',
  warning: 'bg-warning-500',
  danger: 'bg-danger-500',
  info: 'bg-info-500',
  neutral: 'bg-subtle',
}

export const leaveSoft: Record<LeaveColour, string> = {
  brand: 'bg-brand-50 text-brand-700 ring-brand-200/70',
  success: 'bg-success-50 text-success-700 ring-success-500/20',
  warning: 'bg-warning-50 text-warning-700 ring-warning-500/25',
  danger: 'bg-danger-50 text-danger-700 ring-danger-500/20',
  info: 'bg-info-50 text-info-700 ring-info-500/20',
  neutral: 'bg-surface-sunken text-ink-soft ring-line',
}
